// CreateNav — prev/next step navigation + step counter for the create
// wizard. Substrate: design/add.html lines 690-698 — `<nav class="ap-nav">`.
//
// Presentation-only. The draft/publish submit actions live inside the
// final pane's `.ap-final` block (CreateStepDescription), NOT here —
// this nav only walks between steps, mirroring add.html.

function CreateNav({ current, total, onPrev, onNext, nextDisabled = false }) {
  return (
    <nav className="ap-nav" aria-label="Перехід між кроками">
      <button
        type="button"
        className="action-btn"
        onClick={onPrev}
        disabled={current <= 1}
      >
        <i className="fa-solid fa-arrow-left" aria-hidden="true" />
        Назад
      </button>
      <span className="ap-nav__step">
        Крок <strong data-current-step>{current}</strong> із {total}
      </span>
      <button
        type="button"
        className="action-btn action-btn--accent"
        onClick={onNext}
        disabled={current >= total || nextDisabled}
      >
        Далі
        <i className="fa-solid fa-arrow-right" aria-hidden="true" />
      </button>
    </nav>
  );
}

export default CreateNav;
